<template>
	<div class="">
		
		<div>
			<div class="text-right">
				<button class="btn btn-group" v-if="!ifEdit" @click="ifEdit=true">编 辑</button>
				<button class="btn btn-group" v-if="ifEdit" @click="ifEdit=false">取 消</button>
			</div>
			<div class="rights" v-for="(item,index) in rightsList">
				<h3>{{item.username}}</h3>
				<!--未编辑状态-->
				<p class="p4" v-if="!ifEdit" v-for="sitem in item.packet_list">
					<i class="fa fa-dot-circle-o"></i>
					<el-tag type="success">{{sitem.auth_name}}</el-tag>
					<span v-for="ssitem in sitem.group">
						<el-tag>{{ssitem.group_name}}</el-tag>
					</span>
				</p>
				<!--编辑状态-->
				<p class="p4" v-if="ifEdit" v-for="(sitem,sindex) in item.packet_list">
					<i class="fa fa-dot-circle-o"></i>
					<el-tag closable @close="handleClose(item,index,sitem,sindex)" type="success">{{sitem.auth_name}}</el-tag>
					<span v-for="(ssitem,ssindex) in sitem.group">
						<el-tag closable @close="handleClose(item,index,sitem,sindex,ssitem,ssindex)">{{ssitem.group_name}}</el-tag>
					</span>
				</p>
			</div>
		</div>
		<!--删除确认框-->
		<el-dialog title="提示框" :visible.sync="deleteDialogFlag" width="500px" >
		    <div class="userInfo">
				<h4>删除后不可恢复，确认删除吗？</h4>
			</div>
			  <div slot="footer" class="dialog-footer">
			    <el-button @click="deleteDialogFlag = false">取消</el-button>
			    <el-button type="primary" @click="confirmDelete()">确定</el-button>
			  </div>
		</el-dialog>
	</div>
</template>
<script>
export default {
	name:"rights",
  data(){
    return {
    	rightsList:[],
    	ifEdit:false,
    	deleteDialogFlag:false,
    	deleteObj:{},
    	item:{},
    	index:-1,
    	sitem:{},
    	sindex:-1,
    	ssitem:{},
    	ssindex:-1
    }
  },
  mounted(){
    this.$nextTick(function(){
    	this.getRightsList();
  	})
  },

  methods: {
	getRightsList(){
		let rightsListParams={
			uid:this.getCookie('uid'),
	  		time:Date.parse( new Date()),
	  		terminalId:4,
  		};
  		this.sign(rightsListParams);
  		this.$ajax.post(this.$store.state.domain+"/Home/PermissionsList/PermissionsList",this.$qs.stringify(rightsListParams),{
            emulateJSON: true
        }).then(res=>{
        	if(res.data.status==1 && res.data.data){
        		this.rightsList = res.data.data;
        		
        	}else if(res.data.code==10008){
			      this.delCookie('username');
					      this.$router.push('/login/');
					      this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
        	}else{
        		//console.log(res.data.msg);
        	}
  		});
	},
	handleClose(item,index,sitem,sindex,ssitem,ssindex) {
		this.item = {};
        this.index = -1;
        this.sitem = {};
        this.sindex = -1;
        this.ssitem = {};
        this.ssindex = -1;
		this.deleteDialogFlag = true;
        this.item = item;
        this.index = index;
        this.sitem = sitem;
        this.sindex = sindex;
        if(ssitem && ssitem.group_name){
        	this.ssitem = ssitem;
        	this.ssindex = ssindex;
        }
        
        
     },
     confirmDelete(){
     	var rightsListParams;
        var postUrl;
//      点击的是删除分组或者权限，分别调用不同接口
  		if(this.ssitem && this.ssitem.group_name){
  			this.rightsList[this.index].packet_list[this.sindex].group.splice(this.ssindex, 1);
  			postUrl = "/Home/AuthDelFen/AuthDelFen";
  			rightsListParams={
				uid:this.getCookie('uid'),
				username:this.item.username,
				share_id:this.item.share_id || "",
				auth_id:this.sitem.auth_id || "",
				group_name:this.ssitem.group_name || "",
				packet_id:this.ssitem.packet_id || "",
		  		time:Date.parse( new Date()),
		  		terminalId:4,
	  		};
  		}else{
  			this.rightsList[this.index].packet_list.splice(this.sindex, 1);
  			postUrl = "/Home/AuthDel/AuthDel";
  			rightsListParams={
				uid:this.getCookie('uid'),
				username:this.item.username,
				share_id:this.item.share_id || "",
				auth_id:this.sitem.auth_id || "",
				auth_name:this.sitem.auth_name || "",
		  		time:Date.parse( new Date()),
		  		terminalId:4,
	  		};
  		}
  		this.sign(rightsListParams);
  		this.$ajax.post(this.$store.state.domain+postUrl,this.$qs.stringify(rightsListParams),{
            emulateJSON: true
        }).then(res=>{
        	this.deleteDialogFlag = false;
        	if(res.data.status==1){
        		this.$message.success(res.data.msg)
        		
        	}else if(res.data.code==10008){
			      this.delCookie('username');
					      this.$router.push('/login/');
					      this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
        	}else{
        		//console.log(res.data.msg);
        	}
  		});
     }
	
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/device/rights.vue